import { _URL } from "../../config.json";
import http from "../http";

const apiEndpoint = _URL + "/api/StoreTransactionStatePattern";

export function getAllSTSP() {
  return http.get(`${apiEndpoint}`);
}

export function getSTSPById(Id) {
  return http.get(`${apiEndpoint}/${Id}`);
}

export function editSTSP(obj) {
  if (obj.id !== "new" && obj.id !== "add") {
    return http.put(apiEndpoint, obj);
  } else {
    return http.post(apiEndpoint, obj);
  }
}

export function deleteSTSP(Id) {
  return http.delete(`${apiEndpoint}/${Id}`);
}
